import { render } from "./CartNavigation.vue?vue&type=template&id=2c9651e1&scoped=true"
import script from "./CartNavigation.vue?vue&type=script&lang=js"
export * from "./CartNavigation.vue?vue&type=script&lang=js"

import "./CartNavigation.vue?vue&type=style&index=0&id=2c9651e1&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c9651e1"]])

export default __exports__